<template>
	<div class="paid_BJ">
		<div class="paid_top">
			<img src="/static/img/paid_bg_BJ.png" class="paid_bg">
			<div class="circle">
				<img src="/static/img/paid_logo_BJ.png">
			</div>
		</div>
		<div>
			<div class="paid_h3">恭喜您,合同已签订完成</div>
			<div class="paid_h4">欢迎使用众赢投顾服务</div>
		</div>
	</div>	
</template>

<script>
export default {
	name: 'NoQyServiceOrderDone'
}
</script>

<style scoped>
	/*加到vue内的独立样式   start*/
	.paid_BJ{ 
		font-size: 20px;
		max-width: 769px;
		margin: auto;
		color: #bf8700;
		line-height: 1;
	}
	.paid_top{
		position: relative;
	}
	.paid_bg{
		width: 100%
	}
	.circle{
		position: absolute;
		bottom: -56px;
		left: calc(50% - 56px);
		width: 112px;
		height: 112px;
		border-radius: 50%;
		background: #ebc569;
		text-align: center;
	}
	.circle img{
		width: 94px;
		margin-top: 9px;
	}
	.paid_h3{
		margin-top: 76px;
		font-size: 30px;
		text-align: center;
	}
	.paid_h4{
		margin-top: 11px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// NoQyServiceOrderDone.vue?4a651ffb